import facebook from '../Assets/Images/facebook.png';
import reddit from '../Assets/Images/reddit.png';
import instagram from '../Assets/Images/instagram.png';
import youtube from '../Assets/Images/youtube.png';
import twitter from '../Assets/Images/twitter.png';
import twitch from '../Assets/Images/twitch.png';

const socials = [
  {
    name: 'youtube',
    image: youtube,
    href: 'https://www.youtube.com/c/LePerchoirAC',
  },
  {
    name: 'twitter',
    image: twitter,
    href: 'https://twitter.com/LePerchoirAC',
  },
  {
    name: 'twitch',
    image: twitch,
    href: 'https://www.twitch.tv/LePerchoirAC',
  },
  {
    name: 'instagram',
    image: instagram,
    href: 'https://www.instagram.com/LePerchoirAC/',
  },
  {
    name: 'facebook',
    image: facebook,
    href: 'https://www.facebook.com/LePerchoirAC',
  },
  {
    name: 'reddit',
    image: reddit,
    href: 'https://www.reddit.com/r/LePerchoirAC/',
  },
];

export default socials;
